import { render, staticRenderFns } from "./EndosadosTable.vue?vue&type=template&id=8d7f322a"
import script from "./EndosadosTable.vue?vue&type=script&lang=js"
export * from "./EndosadosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports